<template>
  <v-container class="page-container p-0">
    <UserTwoFactorContainer />
  </v-container>
</template>

<script>
import UserTwoFactorContainer from "@/components/Container/UserTwoFactorContainer.vue"
export default {
  components: { UserTwoFactorContainer },
}
</script>
